"use client";

import { useCallback } from "react";
import { toIsoDateOnly } from "@/lib/dateApi";
import { rmcClient } from "@/lib/rmcClient";

export function useRateLookup() {
  const fetchRate = useCallback(async (partyId, gradeId, challanDate) => {
    const day = toIsoDateOnly(challanDate);
    const res = await rmcClient.lookupQuotationRate({
      party_id: partyId,
      grade_id: gradeId,
      ...(day ? { challan_date: day } : {}),
    });
    return res.data?.rate ?? null;
  }, []);
  const fetchRateDetails = useCallback(async (partyId, gradeId, challanDate) => {
    const day = toIsoDateOnly(challanDate);
    const res = await rmcClient.lookupQuotationRate({
      party_id: partyId,
      grade_id: gradeId,
      ...(day ? { challan_date: day } : {}),
    });
    return res.data ?? null;
  }, []);
  return { fetchRate, fetchRateDetails };
}
